/**
 * Occasional signup nudge for guests — same bubble used on /tunes and /abc-tool.
 */

import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useLanguage } from '../context/LanguageContext';
import './RegisterNudgeBubble.css';

const STORAGE_DISMISS = 'tunePlayerBubbleDismissed';
const SHOW_AFTER_MS = 2000;
const AUTO_HIDE_MS = 10000;

const RegisterNudgeBubble = () => {
  const { currentUser } = useAuth();
  const { t } = useLanguage();
  const nudge = t.ui?.nudge;
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (currentUser) return undefined;

    let dismissed = false;
    try {
      dismissed = localStorage.getItem(STORAGE_DISMISS) === 'true';
    } catch {
      /* ignore */
    }
    if (dismissed) return undefined;

    let hideTimer;
    const showTimer = setTimeout(() => {
      setVisible(true);
      hideTimer = setTimeout(() => setVisible(false), AUTO_HIDE_MS);
    }, SHOW_AFTER_MS);

    return () => {
      clearTimeout(showTimer);
      if (hideTimer) clearTimeout(hideTimer);
    };
  }, [currentUser]);

  const handleDismiss = () => {
    setVisible(false);
    try {
      localStorage.setItem(STORAGE_DISMISS, 'true');
    } catch {
      /* ignore */
    }
  };

  if (!visible || currentUser || !nudge) return null;

  return (
    <div className="register-info-bubble" role="dialog" aria-label={nudge.title}>
      <button
        type="button"
        className="bubble-close-btn"
        onClick={handleDismiss}
        aria-label={t.ui.common.close}
      >
        ✕
      </button>
      <div className="bubble-content">
        <div className="bubble-icon" aria-hidden="true">🎵</div>
        <div className="bubble-text">
          <h4>{nudge.title}</h4>
          <p>{nudge.body}</p>
        </div>
        <Link to="/register" className="bubble-cta-btn" onClick={handleDismiss}>
          {nudge.cta}
        </Link>
      </div>
    </div>
  );
};

export default RegisterNudgeBubble;
